import { CustomError } from 'utils/customError'

export class NotFoundError extends CustomError {
  constructor(apiPath: string, originalError: any) {
    let title = 'Tidak ada hasil'
    let description =
      'Cek ejaan Anda, atau ganti kata kunci. Kalau belum ketemu, coba cek Pusat Bantuan.'
    super({ title, description, apiPath, originalError })
  }
}
export class NotFoundWithFiltersError extends CustomError {
  constructor(apiPath: string, originalError: any) {
    let title = 'Tidak ada hasil yang sesuai'
    let description =
      'Edit atau reset kategori untuk melihat hasil pencarian lain.'
    super({ title, description, apiPath, originalError })
  }
}
export class InternalServerError extends CustomError {
  constructor(apiPath: string, originalError: any) {
    let title = 'Terjadi kendala sistem'
    let description = 'Silakan coba lagi dalam beberapa saat.'
    super({ title, description, apiPath, originalError })
  }
}
export class NetworkError extends CustomError {
  constructor(apiPath: string, originalError: any) {
    let title = 'Tidak ada koneksi internet'
    let description =
      'Pastikan koneksi WiFi atau kuota internet Anda aktif, lalu coba lagi.'
    super({ title, description, apiPath, originalError })
  }
}
